import React from 'react';
import './LegalDocument.css';

const Section = ({ section, idPrefix }) => (
  <section id={`${idPrefix}${section.id}`} className="legal-section">
    <h2>{section.heading}</h2>
    {(section.body || []).map((p, i) => (
      <p key={i}>{p}</p>
    ))}
    {section.list && (
      <ul>
        {section.list.map((li, i) => (
          <li key={i}>{li}</li>
        ))}
      </ul>
    )}
    {section.table && (
      // Wrapped because these tables have four columns of Korean prose and the app is
      // used on phones in stores — the wrapper scrolls, the page does not.
      <div className="legal-table-wrap">
        <table>
          <thead>
            <tr>
              {section.table.columns.map((c, i) => (
                <th key={i}>{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {section.table.rows.map((row, i) => (
              <tr key={i}>
                {row.map((c, j) => (
                  <td key={j}>{c}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </section>
);

/**
 * Sections only — no title, no chrome. The onboarding consent box embeds this.
 *
 * `idPrefix` exists because onboarding renders both documents on one page and they share
 * section ids (both have `purpose`). The unprefixed ids are public URL anchors —
 * `/privacy#items` is linked from the session consent modal — so the embeds get prefixed
 * instead of the ids being renamed.
 */
const LegalDocument = ({ doc, idPrefix = '' }) => (
  <div className="legal-document">
    {doc.sections.map((s) => (
      <Section key={s.id} section={s} idPrefix={idPrefix} />
    ))}
  </div>
);

export default LegalDocument;
